<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-18 10:11:26
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-26 17:21:39
 * @FilePath: \合联\oms\src\base\common\component\table-group.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <vxe-colgroup
    :field="field.key"
    v-if="field.children && isMethod(field.show, { fields, field }, true)"
    :title="isMethod(field.name)"
  >
    <template v-for="(cfield, fieldIndex) in field.children">
      <TableGroup :field="cfield" :fields="fields" :key="cfield.key">
        <template
          v-for="slot in cfield.slots"
          #[slot]="{ row, rowIndex, field }"
        >
          <slot
            :name="slot"
            :row="row"
            :rowIndex="rowIndex"
            :field="field"
            :value="row[field.key]"
          ></slot>
        </template>
      </TableGroup>
    </template>
  </vxe-colgroup>
  <TableColumn
    v-else
    :fields="fields"
    :field="field"
    :key="field.key"
    :config="config"
  >
    <template v-if="field.slot" #[field.slot]="{ row, rowIndex, field }">
      <slot
        :name="field.slot"
        :row="row"
        :rowIndex="rowIndex"
        :field="field"
        :value="row[field.key]"
      >
      </slot>
    </template>
  </TableColumn>
</template>

<script>
import TableColumn from "./table-column.vue";
export default {
  name: "TableGroup",
  components: {
    TableColumn,
  },
  inject: {
    $page: "$page",
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function")
        return methods.call(this.$table, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function")
        return methods.call(this.$table, params);
      return methods !== undefined ? methods : df;
    },
  },
};
</script>

<style scoped></style>
